import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "iconamoon:compare-light" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M11.4142 4H8.91421H5.41421C4.88378 4 4.37507 4.21071 4 4.58579C3.62493 4.96086 3.41421 5.46957 3.41421 6V18C3.41421 18.5304 3.62493 19.0391 4 19.4142C4.37507 19.7893 4.88378 20 5.41421 20H11.4142M14.4142 4H17.4142C17.9446 4 18.4534 4.21071 18.8284 4.58579C19.2035 4.96086 19.4142 5.46957 19.4142 6V7M19.4142 17V18C19.4142 18.5304 19.2035 19.0391 18.8284 19.4142C18.4534 19.7893 17.9446 20 17.4142 20H14.4142M19.4142 11V13M11.4142 2V22",
        stroke: "#AA1E2D",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }